import React, { Component, useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FormLayout, TextField, Label } from '@superops/ui-design-system';
import {
  getTranslatedText,
  reactSelectInlineError,
  TEXT_LENGTH,
  PHONE_NUMBER_LENGTH
} from '@nile/components';
import styled from 'styled-components';
import { cloneDeep } from 'lodash';

const ContactWrapper = styled.div`
  .react-tel-input {
    margin-top: 10px;
  }
`;

const CompanyContactForm = (props) => {
  const { intl, index, errors, contact } = props;

  const handleChange = (field, value) => {
    const updatedContact = cloneDeep(contact);
    updatedContact[field] = value;
    props.onChange(updatedContact, index);
  };

  const handlePhoneNumberInput = (value) => {
    const updatedContact = {
      ...contact,
      isTouched: true
    };
    updatedContact.phoneNumber = value.trim();
    updatedContact.contactNumber = value.trim();
    props.onChange(updatedContact, index);
  };

  // render() {
  return (
    <ContactWrapper>
      <FormLayout>
        <TextField
          value={contact.firstName}
          id={'firstname' + index}
          className={'firstname' + index}
          label={getTranslatedText(intl, 'admin.mspDetails.firstName')}
          placeholder={getTranslatedText(intl, 'admin.mspDetails.firstname.pl')}
          type="text"
          maxLength={TEXT_LENGTH.size_4}
          error={errors?.firstName?.[0]}
          onChange={handleChange.bind(this, 'firstName')}
        />
        <TextField
          value={contact.lastName}
          id={'lastname' + index}
          label={getTranslatedText(intl, 'admin.mspDetails.lastName')}
          placeholder={getTranslatedText(intl, 'admin.mspDetails.lastname.pl')}
          type="text"
          maxLength={TEXT_LENGTH.size_4}
          error={errors?.lastName?.[0]}
          onChange={handleChange.bind(this, 'lastName')}
        />
        <>
          <Label>
            <FormattedMessage id="admin.mspDetails.phoneNumber" />
          </Label>
          <TextField
            value={contact?.phoneNumber || contact?.contactNumber || ''}
            onChange={handlePhoneNumberInput}
            maxLength={PHONE_NUMBER_LENGTH}
          />
        </>
        <TextField
          label={getTranslatedText(intl, 'admin.mspDetails.email')}
          placeholder={getTranslatedText(intl, 'admin.mspDetails.email.pl')}
          id={'email' + index}
          type="email"
          value={contact.email}
          maxLength={TEXT_LENGTH.size_5}
          error={errors?.email?.[0]}
          onChange={handleChange.bind(this, 'email')}
        />
      </FormLayout>
    </ContactWrapper>
  );
  // }
};

export default injectIntl(CompanyContactForm);
